import { useTranslate, useRecordContext } from "ra-core";
import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";

import { MobileListPage } from "../layout/MobileListPage";
import type { Company } from "../types";

const CompanyMeta = () => {
  const record = useRecordContext<Company>();
  if (!record) return null;
  return (
    <span className="text-xs text-muted-foreground">
      {record.sector || record.city || "—"}
    </span>
  );
};

/**
 * Companies on a phone.
 *
 * The desktop screen is a grid of logo cards, which wants width. A list reads
 * better in a narrow column and reaches the same records -- the company detail
 * screen was already registered on mobile, so only the way in was missing.
 */
export const MobileCompanyList = () => {
  const translate = useTranslate();

  return (
    <List
      actions={false}
      title={false}
      sort={{ field: "name", order: "ASC" }}
      pagination={<ListPagination rowsPerPageOptions={[25, 50]} />}
    >
      <MobileListPage
        searchPlaceholder={translate("resources.companies.name", {
          smart_count: 2,
        })}
      >
        <DataTable rowClick="show">
          <DataTable.Col source="name" />
          <DataTable.Col label="Sector">
            <CompanyMeta />
          </DataTable.Col>
        </DataTable>
      </MobileListPage>
    </List>
  );
};

export default MobileCompanyList;
